import React from 'react';

import seanImage from '../../../assets/JoinedEmailPage/littleSean.png';
import Button from '../../UI/Button/Button';
import { Paper, Typography, Link, Box, Tooltip, Zoom } from '@mui/material';
import '@typeform/embed/build/css/popup.css';

import { useCallback } from 'react';
import Particles from 'react-particles';
import particlesConfig from './particlesConfig.js';
import { loadFull } from 'tsparticles';

const Body = () => {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  return (
    <Box align='center' flexDirection='column' alignItems='center' justifyContent='center' display='flex'>
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: 'auto',
          zIndex: -1,
        }}>
        <Particles
          height='100vh'
          width='100vh'
          id='tsparticles'
          init={particlesInit}
          loaded={particlesLoaded}
          options={particlesConfig}
        />
      </Box>
      <Paper
        elevation={20}
        sx={{
          zIndex: 1,
          width: { sm: '100%', md: '80%', lg: '75%' },
          p: '3rem',
          mt: '2rem',
          borderRadius: 5,
        }}>
        {/* <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "secondary.main",
            mb: "1rem",
          }}
        >
          YOUR MASTERMIND
        </Typography> */}
        <Typography
          variant='h4'
          component='h2'
          sx={{
            fontWeight: 'bold',
            maxWidth: { xs: '100%', md: '85%' },
            textAlign: 'center',
            mx: 'auto',
          }}>
          Thanks for joining our newsletter.
        </Typography>
        <Typography
          variant='body1'
          sx={{
            mt: '2rem',
            maxWidth: { xs: '100%', md: '85%' },
            px: { xs: '0px', sm: '2rem' },
            mx: 'auto',
            textAlign: 'center',
          }}>
          <Tooltip title='Hello!' placement='top' TransitionComponent={Zoom} arrow>
            <Box
              component='img'
              src={seanImage}
              alt={'little Sean'}
              sx={{
                verticalAlign: 'middle',
                maxHeight: '100px',
                borderRadius: '20px',
                mx: 'auto',
                mb: '1rem',
              }}
            />
          </Tooltip>
          <br></br>
          Hey! 👋 I'm Sean Tan, the co-founder of The 100 Club. <br></br>
          <br></br>Thanks for subscribing to our free weekly newsletter, You are now officially a Friend of The 100
          Club! I have just sent you a welcome email - check your spam folder if you don't see it!<br></br>
          <br></br> It’d be great if you could <b>reply to let me know that you received it.</b> And if you're up for
          it, tell me a bit about yourself and your goals. I make sure to reply to all emails I get from newsletter
          subscribers. Looking forward to hearing from you! <br></br>
          <br></br>
          <b>
            P.S. If you're a founder, I'd like to personally invite you to join The 100 Club, a private mastermind
            community for founders in Singapore 👇
          </b>
        </Typography>
        <Link
          key={1}
          href='/payments'
          sx={{
            textDecoration: 'none',
            display: 'block',
            textAlign: 'center',
            mt: '3rem',
          }}>
          <Button text='Join The 100 Club' symbol='arrow' />
        </Link>
      </Paper>
    </Box>
  );
};

export default Body;
